import { connect } from "react-redux";
import { FilterSelect as Filter } from "MODULES/shared/components";

export default connect(undefined, (dispatch, { search }) => ({
  setFilters: filters => dispatch(search.setFilters(filters))
}))(Filter);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Pagination/FilterSelect.jsx